import Line from './line';
import Area from './area';
import Column from './column';
import Progress from './progress';
import Ring from './ring';
export var Tiny = { Line: Line, Area: Area, Column: Column, Progress: Progress, Ring: Ring };
